import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageSelector } from '~/GlobalRedux/Features/language/languageSlice';
import {
  setSuccess,
  successSelector,
} from '~/GlobalRedux/Features/success/successSlice';

interface SuccessSnackbarProps {
  title?: string;
  message: string;
}

const SuccessSnackbar: React.FC<SuccessSnackbarProps> = ({
  title,
  message,
}) => {
  const isSuccess = useSelector(successSelector);
  const dispatch = useDispatch();

  const lang = useSelector(languageSelector);
  const text = {
    pt: 'Sua solicitação foi registrada!',
    en: 'Your request has been registered!',
    es: '¡Su solicitud ha sido registrada!',
  };

  return (
    <>
      {isSuccess && (
        <div className="fixed bottom-0 right-0 mb-8 mr-8 rounded-md bg-secundaria-verdebroto50 px-6 py-4 text-white">
          <p className="mb-2 text-xl font-bold">{title ?? text[lang]}</p>
          <p>{message}</p>
          <button
            className="mt-2 rounded bg-white px-4 py-2 text-secundaria-verdebroto50"
            onClick={() => dispatch(setSuccess(false))}
          >
            Fechar
          </button>
        </div>
      )}
    </>
  );
};

export default SuccessSnackbar;
